import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class Vat extends BaseEntity{

    vatCode : string;
    name : string;
    vatRate : number;
    rank : number;

}
